'use strict';

/**
 *
 * @name: nownessApp.navigation
 *
 */

// import CategoryStripMenuDirective from './nn-category-strip-menu/nn-category-strip-menu.directive';
import NnMainNavigationDirective from './nn-main-navigation/nn-main-navigation.directive';
import NnTaxonomiesNavigationDirective from './nn-taxonomies-navigation/nn-taxonomies-navigation.directive';
import nnUserNavigationDirective from './nn-user-navigation/nn-user-navigation.directive';

import NavigationAnalyticsFactory from './nn-navigation-analytics.factory';

// Styles
import './chinese-mega-menu.scss';

const NavigationModule = angular
  .module('nownessApp.navigation', [])
  // .directive('categoryStripMenu', CategoryStripMenuDirective)
  .directive('nnMainNavigation', NnMainNavigationDirective)
  .directive('nnTaxonomiesNavigation', NnTaxonomiesNavigationDirective)
  .directive('nnUserNavigation', nnUserNavigationDirective)
  .factory('navigationAnalytics', NavigationAnalyticsFactory);

export default NavigationModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-navigation/nn-navigation.module.js